import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col, ListGroup, ListGroupItem } from "reactstrap";

const footerQuickLinks = [
  {
    display: "Home",
    url: "/",
  },
  {
    display: "Courses",
    url: "/courses",
  },
  {
    display: "Community",
    url: "/community",
  },
  {
    display: "Blog",
    url: "https://seedtotreeacademy.blogspot.com",
  },
];

const footerInfoLinks = [
  {
    display: "Privacy Policy",
    url: "/legal/privacy-policy",
  },
  {
    display: "Terms and Conditions",
    url: "/legal/terms-and-conditions",
  },
  {
    display: "Be a Member",
    url: "https://forms.gle/6J8EWRBuPRhjPbJQ6",
  },
  {
    display: "Join as Teacher",
    url: "https://forms.gle/6YYvW5mTgQX8EuRv5",
  },
];

const Footer = () => {
  return (
    <footer className="footer ">
      <Container>
        <Row>
          <Col lg="3" md="6" className="mb-4">
            <h2 className=" d-flex align-items-center gap-1">
              <img
                loading="lazy"
                src="/assets/images/logos/logo.webp"
                alt="Seed To Tree"
                title="Seed To Tree"
                width={50}
                height={50}
              />{" "}
              SEED TO TREE
            </h2>

            <div className="follows">
              <h3 className="mb-0">Follow us on social media</h3>
              <span>
                {" "}
                <Link
                  aria-label="Follow us on Facebook"
                  to="https://www.facebook.com/seedtotree.info"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="ri-facebook-line"></i>
                  <span>Follow us on Facebook</span>
                </Link>
              </span>

              <span>
                {" "}
                <Link
                  aria-label="Follow us on Instagram"
                  to="https://www.instagram.com/seedtotree.info"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="ri-instagram-line"></i>
                  <span>Follow us on Instagram</span>
                </Link>
              </span>

              <span>
                <Link
                  aria-label="Follow us on Whatsapp Channel"
                  to="https://wa.me/+923405021470"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="ri-whatsapp-line"></i>
                  <span>Follow us on Whatsapp Channel</span>
                </Link>
              </span>

              <span>
                <Link
                  aria-label="Follow us on Youtube"
                  to="https://www.youtube.com/@seedtotree-info/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="ri-youtube-line"></i>
                  <span>Follow us on Youtube</span>
                </Link>
              </span>
            </div>
          </Col>

          <Col lg="3" md="6" className="mb-4">
            <h3 className="fw-bold">Explore</h3>
            <ListGroup className="link__list">
              {footerQuickLinks.map((item, index) => (
                <ListGroupItem key={index} className="border-0 ps-0 link__item">
                  <Link to={item.url}>{item.display}</Link>
                </ListGroupItem>
              ))}
            </ListGroup>
          </Col>

          <Col lg="3" md="6" className="mb-4">
            <h3 className="fw-bold">Information</h3>
            <ListGroup className="link__list">
              {footerInfoLinks.map((item, index) => (
                <ListGroupItem key={index} className="border-0 ps-0 link__item">
                  <Link to={item.url}>{item.display}</Link>
                </ListGroupItem>
              ))}
            </ListGroup>
          </Col>

          <Col lg="3" md="6">
            <h3 className="fw-bold">Get in Touch</h3>

            <p>Address: Islamabad, Pakistan</p>
            <p> Phone: +92 3405021470 </p>
            <p>Email: seedtotree.info@gmail.com</p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
